import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import DashboardLayout from '../../components/Layout/DashboardLayout'
import Sidebar from '../../components/Sidebar/Sidebar'
import HospitalSelector from '../../components/Header/HospitalSelector'
import StatusAtGlance from './StatusAtGlance'
import EducationMeasures from './EducationMeasures'
import EngagementMeasures from './EngagementMeasures'
import OutcomeMeasures from './OutcomeMeasures'
import StructureMeasures from './StructureMeasures'
import PremCompletion from './PremCompletion'
import PremAgreement from './PremAgreement'
import PremDisagreement from './PremDisagreement'
import UnderConstruction from '../../components/Common/UnderConstruction'

const RedirectWithParams: React.FC<{ to: string }> = ({ to }) => {
    const location = useLocation()
    return <Navigate to={`${to}${location.search}`} replace />
}

const BCBSIndex: React.FC = () => {
    const sidebarLinks = [
        { label: 'Status at a Glance', path: '/bcbs/status/' },
        {
            label: 'Engagement & Participation',
            submenu: [
                { label: 'Engagement Measures', path: '/bcbs/engagement/' },
                { label: 'Structure Measures', path: '/bcbs/structure-measures/' },
                { label: 'Education Measures', path: '/bcbs/education/' },
            ]
        },
        {
            label: 'PREM',
            submenu: [
                { label: 'Completion', path: '/bcbs/prem-completion/' },
                { label: 'Patient Agreement', path: '/bcbs/prem-agreement/' },
                { label: 'Patient Disagreement', path: '/bcbs/prem-disagreement/' },
            ]
        },
        { label: 'Outcome Measures', path: '/bcbs/outcome/' }
    ]

    const exportPages = [
        { id: 'status', title: 'Status at a Glance', url: '/bcbs/status/' },
        { id: 'engagement', title: 'Engagement Measures', url: '/bcbs/engagement/' },
        { id: 'structure-measures', title: 'Structure Measures', url: '/bcbs/structure-measures/' },
        { id: 'education', title: 'Education Measures', url: '/bcbs/education/' },
        { id: 'prem-completion', title: 'PREM Completion', url: '/bcbs/prem-completion/' },
        { id: 'prem-agreement', title: 'Patient Agreement', url: '/bcbs/prem-agreement/' },
        { id: 'prem-disagreement', title: 'Patient Disagreement', url: '/bcbs/prem-disagreement/' },
        { id: 'outcome', title: 'Outcome Measures', url: '/bcbs/outcome/' }
    ]

    return (
        <DashboardLayout
            sidebar={
                <Sidebar
                    logo="/logo1.webp"
                    links={sidebarLinks}
                    exportPages={exportPages}
                    exportTitle="BCBS Dashboard Export"
                />
            }
            header={<HospitalSelector />}
        >
            <Routes>
                <Route path="/" element={<RedirectWithParams to="/bcbs/status/" />} />
                <Route path="/status/" element={<StatusAtGlance />} />
                <Route path="/education/" element={<EducationMeasures />} />
                <Route path="/engagement/" element={<EngagementMeasures />} />
                <Route path="/outcome/" element={<OutcomeMeasures />} />
                <Route path="/prem-completion/" element={<PremCompletion />} />
                <Route path="/prem-agreement/" element={<PremAgreement />} />
                <Route path="/prem-disagreement/" element={<PremDisagreement />} />
                <Route path="/structure-measures/" element={<StructureMeasures />} />
                <Route path="*" element={<RedirectWithParams to="/bcbs/status/" />} />
            </Routes>
        </DashboardLayout>
    )
}

export default BCBSIndex
